.sidebar,
.additional-entries {
  display: flex;
  flex-flow: column nowrap;

  gap: var(--mantine-spacing-xs);
  align-items: center;
}

.sidebar {
  z-index: 100;
  grid-area: sidebar;
  width: calc(4rem * var(--mantine-scale));
  padding: var(--mantine-spacing-xs);
  overflow: hidden auto;
  background: alpha(light-dark(var(--mantine-color-dark-7), var(--mantine-color-dark-7), 1));
  box-shadow:
    1px 0 1.2rem #00000010,
    1px 0 calc(var(--mantine-spacing-md) * 0.4) #00000010;
  backdrop-filter: blur(var(--mantine-spacing-xl));
}

.logo-container {
  position: relative;
  display: flex;
  flex: 0 1 auto;
  flex-flow: column nowrap;
  padding-block-end: var(--mantine-spacing-xs);
  border-bottom: 1px solid var(--mantine-color-dark-5);
}

.logo {
  flex: 0 1 auto;
  text-decoration: none;
  svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.additional-entries {
  margin-top: auto;
}

.portal {
  display: contents;
}

.entry-error {
  pointer-events: none;
  opacity: 0.5;
}

.entry-loading {
  pointer-events: none;
  opacity: 0.5;
}
